import reasonService from "src/services/reasonService";

export const GET_INTERNAL_REASON_REQUEST = "@cancel-reason/get-internal-reason-request";
export const GET_INTERNAL_REASON_SUCCESS = "@cancel-reason/get-internal-reason-success";
export const GET_INTERNAL_REASON_FAILURE = "@cancel-reason/get-internal-reason-failure";

// export const GET_CUSTOMER_REASON_REQUEST = "@cancel-reason/get-customer-reason-request";
// export const GET_CUSTOMER_REASON_SUCCESS = "@cancel-reason/get-customer-reason-success";
// export const GET_CUSTOMER_REASON_FAILURE = "@cancel-reason/get-customer-reason-failure";

export function getInternalReasonData(params) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_INTERNAL_REASON_REQUEST});
      const response = await reasonService.getCancelReasons(params);
      dispatch({
        type: GET_INTERNAL_REASON_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_INTERNAL_REASON_FAILURE});
      throw error;
    }
  };
}

// export function getCustomerReasonData(params) {
//   return async (dispatch) => {
//     try {
//       dispatch({type: GET_CUSTOMER_REASON_REQUEST});
//       const response = await reasonService.getCancelReasons(params);
//       dispatch({
//         type: GET_CUSTOMER_REASON_SUCCESS,
//         payload: {
//           response
//         }
//       });
//     } catch (error) {
//       dispatch({type: GET_CUSTOMER_REASON_FAILURE});
//       throw error;
//     }
//   };
// }
